import './App.css';
import Banner from './components/Banner';
import Bio from './components/Bio';
import ContentContainer from './components/ContentContainer';
import alphaBlogs from './utils/AlphaBlogData';
import blogs from './utils/BlogData';
import essays from './utils/EssayData';
import gameBlogs from './utils/GamesData';
import Box from '@mui/material/Box';
import { Grid, Typography } from '@mui/material';
import getRandomPercent from './utils/RandomPercent';
import Footer from './components/Footer';
import {useMemo, useState, useEffect, lazy} from 'react';
import {sliders} from './utils/SliderData';
import MobileSlider from './components/MobileSlider/MobileSlider';
import SocialsMobile from './components/MobileSlider/SocialsMobile';
import SwitchButtons from './components/SwitchButtons';
import Showcase from './components/Showcase';
const Feed = lazy(() => import('./components/Slider/Feed'));

function App() {

  const [theme, setTheme] = useState(localStorage.getItem('theme') ?? 'dark');

  const [colorGradients, setColorGradients] = useState([]);
  const [isSwitchMobile, setIsSwitchMobile] = useState(true);
  const contentTypes = {
    alpha: 'alphaBlogs',
    proto: 'blogs',
    essay: 'essays',
    game: 'gameBlogs'
  };

  const switchButtonTexts = [
    {
      text: isSwitchMobile ? 'ALPHA BLOGS' : 'ALPHA UPDATES',
      content: contentTypes.alpha
    },
    {
      text: isSwitchMobile ? 'EARLY BLOGS' : 'PROTOTYPE UPDATES 06/23/25 - 12/15/25',
      content: contentTypes.proto
    },
    {
      text: 'ESSAY BLOGS',
      content: contentTypes.essay
    },
    {
      text: 'GAME BLOGS',
      content: contentTypes.game
    }
  ];

  const [activeContent, setActiveContent] = useState(contentTypes.alpha);
  const [scrollToLatest, setScrollToLatest] = useState(false);

  const [isEssayMobile , setIsEssayMobile] = useState(true);
  

  //es6 computed property names
  const contentMap = useMemo(() => ({
    [contentTypes.alpha]: alphaBlogs,
    [contentTypes.proto]: blogs,
    [contentTypes.essay]: essays,
    [contentTypes.game]: gameBlogs,
  }), [
    contentTypes.alpha, 
    contentTypes.essay, 
    contentTypes.proto,
    contentTypes.game
  ]);

  useEffect(()=>{
    console.log(contentMap);
    console.log("this is alpha ", alphaBlogs);
    console.log(activeContent);
    console.log(contentMap[activeContent]);
    setExpanded(Array(contentMap[activeContent].length).fill(false));
  },[activeContent, contentMap]);

  useEffect(() => {
    const newGradients = Array(alphaBlogs.length).fill(0).map(() => getRandomPercent());
    setColorGradients(newGradients);
  }, []);

  useEffect(() => {
    const root = document.documentElement;

    if (theme === 'light') {
      root.style.setProperty('--link-color', 'black');
      root.style.setProperty('--background-color', 'white');
      root.style.setProperty('--contra-background-color', 'black');
      root.style.setProperty('--title-trans', 0.65);
    } else {
      root.style.setProperty('--link-color', 'white');
      root.style.setProperty('--background-color', 'black');
      root.style.setProperty('--contra-background-color', 'white');
      root.style.setProperty('--title-trans', 0.9);
    }
  }, [theme]);

  useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])

  const handleResize = () => {
      setIsEssayMobile(window.innerWidth < 480);
      setIsSwitchMobile(window.innerWidth < 632);
  };

  const changeTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    localStorage.setItem('theme', newTheme);
    setTheme(newTheme);
  };

  const [expanded, setExpanded] = useState(Array(blogs.length).fill(false));

  const handleAccordionChange = (index) => {
    setExpanded((prevExpanded) => {
      const newExpanded = [...prevExpanded];
      newExpanded[index] = !newExpanded[index];
      return newExpanded;
    });
  };

  const openLatest = () => {
    setActiveContent(contentTypes.alpha);
    setScrollToLatest(true);
  };

  useEffect(() => {
    const activeLength = contentMap[activeContent].length;
    if (scrollToLatest && activeLength > 0) {
      setExpanded(new Array(activeLength).fill(false).map((_, i) => i === activeLength - 1));
    }
  }, [activeContent, contentMap, scrollToLatest]);

  useEffect(() => {
    if (scrollToLatest && expanded[expanded.length - 1]) {
      const currentActiveContent = contentMap[activeContent];
      const latestAccordion = document.getElementById(currentActiveContent[currentActiveContent.length - 1].id);
      if (latestAccordion) {
        setTimeout(() => {
          latestAccordion.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
          setScrollToLatest(false);
        }, 200);
      }
    }
  }, [activeContent, contentMap, expanded, scrollToLatest]);

  return (
    <>
       <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: 'calc((100vw - 936px) / 2)',
          height: '673px',
          backgroundColor: 'black',
          zIndex: 1000
        }}
      /> 
      <Box
        component='main'
        sx={{
          display: 'grid',
          width: '100%',
          backgroundColor: theme === 'light' ? 'white' : 'black'
        }}>
        <Banner theme={theme} changeTheme={changeTheme} />
        <Typography
          align='right'
          sx={{
            paddingRight: '1rem',
            paddingBottom: '1vw',
            color: 'grey',
            fontSize: '0.95rem',
            fontWeight: 'bold',
            '@media (max-width: 500px)': {
              fontSize: '3vw'
            }
          }}
        >
          Sin City by Frank Miller, published by Darkhorse Comics
        </Typography>
        <Bio gradientValues={[colorGradients.at(-1), colorGradients.at(-2), colorGradients.at(-3)]} theme={theme} />
        <Feed 
          openLatest={openLatest} 
          sliders={sliders} 
          gradientValuesArray={[colorGradients.at(-4), colorGradients.at(-5)]}
          theme={theme} 
        />
        <Grid 
          container
          direction="column"
          sx={{
            gap: {
              xs: '2.5vw',
              md: '16px'
            }
          }}>
            <Grid item xs={12} sx={{ display: { xs: 'none', md: 'block' } }}>
                <Box sx={{ height: '250px' }} />
            </Grid>
            <Grid item xs={12} sx={{ display: { xs: 'block', md: 'none' } }}>
              <SocialsMobile />
            </Grid>
            {[...sliders].reverse().map((i,j) => (
              <Grid key={j} item xs={12} sx={{ display: { xs: 'block', md: 'none' } }}>
                <MobileSlider {...i} isMobile={true} openLatest={openLatest} />
              </Grid>
            ))}
            <Grid item xs={12}>
              {!isEssayMobile && <Showcase />}
            </Grid>
            <Grid item xs={12}>
              <SwitchButtons 
                activeContent={activeContent}
                setActiveContent={setActiveContent} 
                texts={switchButtonTexts}
              />
            </Grid>
              <ContentContainer 
                expanded={expanded} 
                colorGradients={colorGradients} 
                contents={contentMap[activeContent]}
                isBlog={activeContent !== 'essays' && activeContent !== 'gameBlogs'}
                fn={activeContent}
                isMobile={isEssayMobile} 
                handleAccordionChange={handleAccordionChange} 
              />
          <Grid item xs={12}>
            <Footer />
          </Grid>
        </Grid>
        
      </Box>
    </>
  );
}

export default App;
